import { createContext, useContext } from "react";
import { Tenant } from "../models/tenant";

export const TenantContext = createContext<Tenant | undefined>(undefined);

export function useTenantContext() {
  const context = useContext(TenantContext);
  return context;
}
